import { YLanguage } from '../y/i18n';
import { YCountryId, YDateString, YFlags, YId, YTimeString } from '../y/types';
import { c_cities, CCityId } from './c-city';
import { LPermission } from './l-permission';

export type CAccountStatus = 'none' | 'cancelled' | 'active' | 'pastdue' | 'giftcard' | 'free' | 'pending_cancel' | 'pending_pause' | 'paused';
export type CRecurringStatus = 'active' | 'inactive' | 'pastdue' | 'paused';
export type MNotificationSetting = 'recommendation_emails' | 'push_events' | 'push_friends' | 'push_offers' | 'sms_standby' | 'sms_events';
export type CSubscriptionType = 'paid' | 'gc' | 'free';
export type CPaidPlanId = 'standard' | 'plusone';
export type CPlanId = 'standard' | 'plusone' | 'vip';

export interface CSubscription {
    type: CSubscriptionType;
    plan: CPlanId;
    start_date: YDateString;
    end_date: YDateString;
}

export interface CUserCommon {
    recurring_status: CRecurringStatus;
    plan?: CPlanId;
    subscription_type?: CSubscriptionType;
}

export type CUserFlag = 'name_open' | 'hide_activity' | 'influencer';

export interface CUser {
    id: YId;
    analytics_id: string;
    is_test: boolean;
    permissions: YFlags<LPermission>;
    email?: string;
    phone?: string;
    country: YCountryId;
    city_id: CCityId;
    first_name: string;
    last_name: string;
    invite_code: string;
    gender?: string;
    birth_year?: string;
    avatar_id?: YId;
    language: YLanguage;
    recurring_status: CRecurringStatus;
    plan?: CPlanId;
    payment_date?: YDateString;
    subscription_type?: CSubscriptionType;
    subscription_start?: YDateString;
    subscription_end?: YDateString;
    first_subscribed_on?: YDateString;
    preferences: Record<string, string>;
    messages: YFlags<MNotificationSetting>;
    flags: YFlags<CUserFlag>;
    created_at: YTimeString;
    last_login_at?: YTimeString;
}

export interface CLoginUser extends CUser {

}

export const c_status_name: Record<CAccountStatus, string> = {
    active: 'Active',
    pending_cancel: 'Pending cancellation',
    pending_pause: 'Pending pause',
    paused: 'Paused',
    pastdue: 'Past due',
    giftcard: 'Giftcard',
    cancelled: 'Cancelled',
    free: 'Free',
    none: 'None'
}

export function cUserFullName(user: CUser) {
    return user.first_name + ' ' + user.last_name;
}

export function cUserAccountStatus(user: CUserCommon): CAccountStatus {
    switch(user.recurring_status) {
        case 'active':
            return 'active';
        case 'pastdue':
            return 'pastdue';
        case 'paused':
            if(user.subscription_type)
                return 'pending_pause';
            else
                return 'paused';
        case 'inactive':
            if(user.subscription_type == 'gc')
                return 'giftcard';
            else if(user.subscription_type == 'free')
                return 'free';
            else if(user.subscription_type)
                return 'pending_cancel';
            else if(user.plan)
                return 'cancelled';
            else
                return 'none';
    }
}

export function cUserAnalyticsProfile(user: CUser): Record<string, any> {
    return {
        country: user.country,
        createdAt: user.created_at,
        email: user.email,
        firstName: user.first_name,
        gender: user.gender,
        id: user.id,
        lastName: user.last_name,
        memberSince: user.created_at,
        phone: user.phone,
        registeredCity: c_cities.maybe(user.city_id)?.name,
        testAccount: user.is_test
    }
}
